
import CenterImg from "@/components/centerImg/centerImg.vue";
import LeftRedTitle from "@/components/leftRedTitle/leftRedTitle.vue";
export default {
  inject:['showFooter','switchHeaderStatus'],
  head() {
    return {
      script: [
        { src: 'https://hm.baidu.com/hm.js?bca287ea2f695c8758d364d29d58ef85' }
      ]
    }
  },
  data(){
    return {
      branchList: [
        // {id:1, title: '沛鸿深圳公司(沛鸿电子大厦)', address: '深圳南山高新科技园科慧路 1 号'},
        {id:2, title: '惠州龙门多泰生产基地', address: '惠州市龙门县金龙大道旁', company: '龙门多泰工业有限公司'},
        // {id:3, title: '沛鸿南通公司', address: '江苏南通通州城东新区朝霞东路',  company: '龙门多泰工业有限公司'},
        {id:4, title: '台北公司', address: '台湾省台北市南京东路 5 段 59 巷 30 弄 14 号 1 楼(105)',company: '多泰实业有限公司'},
        {id:5, title: '香港公司', address: '新界荃湾青山公路 611-619 号 东南工业大厦 18 楼 B 室',  company: '多泰实业公司'},
        {id:6, title: '美国洛杉机公司', address: 'Los Angeles, CA, USA'},
      ],
      infoList: [
        {
          id: 1,
          title: '沛鸿总公司',
          img: require('../assets/img/concact/peihong_icon_1.png'),
          descript: ['地址：中国深圳南山区科技园科慧路1号']
        },
        {
          id: 2,
          title: '联系电话',
          img: require('../assets/img/concact/peihong_icon_2.png'),
          descript: [ '0755-26500951', '0755-26544188', '15986733519（周小姐）', '15989315108（微信）']
        },
        {
          id: 3,
          title: 'E-mail',
          img: require('../assets/img/concact/peihong_icon_3.png'),
          descript: ['sales@winindustry.com', 'marketing@winindustry.com']
        },
        {
          id: 4,
          title: '服务时间',
          img: require('../assets/img/concact/peihong_icon_4.png'),
          descript: ['周一至周五 08:30-18:30']
        },
      ]
    }
  },
  mounted(){
    // 显示footer
    this.showFooter(true)
    this.switchHeaderStatus(true)
  },
  components:{
    CenterImg,
    LeftRedTitle
  }
}
